import Toast from '@/component/Toast'
import { KULEWEBVIEW } from '@/config/constant'
import AuthContext from '@/context/AuthContext'
import { PopUpStore } from '@/store/PopupStore'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

const useAppLogin = () => {
  const { t } = useTranslation('uc')
  const { loginFromSDK } = useContext(AuthContext)

  const appLogin = async () => {
    if (KULEWEBVIEW) {
      try {
        await loginFromSDK()
        Toast.show({
          content: t('message.loginSuccess', { ns: 'uc' })
        })
      } catch (error) {
        Toast.show({
          content: t('message.loginFail', { ns: 'uc' })
        })
      }
    } else {
      PopUpStore.setLoginPopupVisible(true)
      return
    }
  }

  return appLogin
}

export default useAppLogin
